import * as React from "react";
import { IconClose } from "@douyinfe/semi-icons";
import { cssClasses } from '@douyinfe/semi-foundation/lib/es/image/constants';
import cls from "classnames";
import { PreviewContext } from "./previewContext";
const prefixCls = `${cssClasses.PREFIX}-preview-header`;
const Header = _ref => {
  let {
    onClose,
    titleStyle,
    className,
    renderHeader
  } = _ref;
  return /*#__PURE__*/React.createElement(PreviewContext.Consumer, null, _ref2 => {
    let {
      currentIndex,
      titles
    } = _ref2;
    let title;
    if (titles && typeof currentIndex === "number") {
      title = titles[currentIndex];
    }
    return /*#__PURE__*/React.createElement("section", {
      className: cls(prefixCls, className)
    }, /*#__PURE__*/React.createElement("section", {
      className: `${prefixCls}-title`,
      style: titleStyle
    }, renderHeader ? renderHeader(title) : title), /*#__PURE__*/React.createElement("section", {
      className: `${prefixCls}-close`,
      onMouseUp: onClose
    }, /*#__PURE__*/React.createElement(IconClose, null)));
  });
};
export default Header;